import { GetExternalLookupResponseDTO } from '@/api/lookup/DTOs';
import { ILookup } from '@/typings';

export const adaptGetExternalLookupResponseToExternalLookup = (
  externalLookupResponse: GetExternalLookupResponseDTO,
): ILookup[] => {
  return (
    externalLookupResponse?.map(lookupItem => ({
      id: lookupItem.id.toString(),
      name: lookupItem.name,
      shortName: lookupItem.shortName,
    })) ?? []
  );
};
